import { render, staticRenderFns } from "./AttendanceList.vue?vue&type=template&id=1fa4f1f8&scoped=true"
import script from "./AttendanceList.vue?vue&type=script&lang=js"
export * from "./AttendanceList.vue?vue&type=script&lang=js"
import style0 from "./AttendanceList.vue?vue&type=style&index=0&id=1fa4f1f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4f1f8",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});
